/* ─── THREADED CACTUS THEME JS ─── */

(function() {
  'use strict';

  // ─── SCROLL ANIMATIONS ───
  const fadeObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const siblings = Array.from(entry.target.parentElement.querySelectorAll('.fade-up'));
        const idx = siblings.indexOf(entry.target);
        setTimeout(() => entry.target.classList.add('visible'), idx * 80);
        fadeObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });
  document.querySelectorAll('.fade-up').forEach(el => fadeObserver.observe(el));

  // ─── STICKY HEADER SHADOW ───
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 20);
    }, { passive: true });
  }

  // ─── MOBILE NAV ───
  const hamburger = document.getElementById('nav-hamburger');
  const mobileNav = document.getElementById('mobile-nav');
  const mobileClose = document.getElementById('mobile-nav-close');
  const mobileOverlay = document.getElementById('mobile-nav-overlay');

  function openMobileNav() {
    mobileNav && mobileNav.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileNav() {
    mobileNav && mobileNav.classList.remove('open');
    document.body.style.overflow = '';
  }
  hamburger && hamburger.addEventListener('click', openMobileNav);
  mobileClose && mobileClose.addEventListener('click', closeMobileNav);
  mobileOverlay && mobileOverlay.addEventListener('click', closeMobileNav);

  // ─── CART DRAWER ───
  const cartDrawer = document.getElementById('cart-drawer');
  const cartOverlay = document.getElementById('cart-overlay');

  window.openCartDrawer = function() {
    cartDrawer && cartDrawer.classList.add('open');
    cartOverlay && cartOverlay.classList.add('visible');
    document.body.style.overflow = 'hidden';
    refreshCartDrawer();
  };
  window.closeCartDrawer = function() {
    cartDrawer && cartDrawer.classList.remove('open');
    cartOverlay && cartOverlay.classList.remove('visible');
    document.body.style.overflow = '';
  };

  cartOverlay && cartOverlay.addEventListener('click', window.closeCartDrawer);
  document.querySelectorAll('[data-cart-trigger]').forEach(btn => {
    btn.addEventListener('click', window.openCartDrawer);
  });
  document.querySelectorAll('[data-cart-close]').forEach(btn => {
    btn.addEventListener('click', window.closeCartDrawer);
  });

  // ─── REFRESH CART DRAWER ───
  function refreshCartDrawer() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        updateCartCount(cart.item_count);
        renderCartItems(cart);
      })
      .catch(err => console.warn('Cart fetch error:', err));
  }

  function updateCartCount(count) {
    document.querySelectorAll('.cart-count').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function renderCartItems(cart) {
    const body = document.querySelector('.cart-drawer-body');
    const subtotalEl = document.querySelector('.cart-subtotal-amount');
    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML = `
        <div class="cart-empty">
          <div class="cart-empty-icon">🛒</div>
          <p>Your cart is empty.</p>
          <a href="/collections/all" class="btn btn-primary btn-sm" onclick="window.closeCartDrawer()">Start Shopping</a>
        </div>`;
      if (subtotalEl) subtotalEl.textContent = '$0.00';
      return;
    }

    body.innerHTML = cart.items.map(item => `
      <div class="cart-item" data-line-key="${item.key}">
        <div class="cart-item-img">
          <img src="${item.image}" alt="${item.product_title}" loading="lazy">
        </div>
        <div class="cart-item-info">
          <div class="cart-item-title">${item.product_title}</div>
          ${item.variant_title !== 'Default Title' ? `<div class="cart-item-variant">${item.variant_title}</div>` : ''}
          ${renderLineItemProperties(item.properties)}
          <div class="cart-item-price">${formatMoney(item.final_line_price)}</div>
          <div class="cart-qty">
            <button onclick="updateCartItem('${item.key}', ${item.quantity - 1})" aria-label="Decrease">−</button>
            <span>${item.quantity}</span>
            <button onclick="updateCartItem('${item.key}', ${item.quantity + 1})" aria-label="Increase">+</button>
          </div>
        </div>
      </div>`).join('');

    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
  }

  function renderLineItemProperties(properties) {
    if (!properties) return '';
    const entries = Object.entries(properties).filter(([key, value]) => value !== null && value !== '' && !key.startsWith('_'));
    if (!entries.length) return '';
    return `<div class="cart-item-properties">${entries.map(([key, value]) => {
      const safeValue = typeof value === 'string' && /https?:\/\//.test(value)
        ? `<a href="${value}" target="_blank" rel="noopener">${value.split('/').pop()}</a>`
        : value;
      return `<div class="cart-item-property"><span>${key}:</span> ${safeValue}</div>`;
    }).join('')}</div>`;
  }

  window.updateCartItem = function(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
    })
    .then(r => r.json())
    .then(cart => { updateCartCount(cart.item_count); renderCartItems(cart); })
    .catch(err => console.warn('Cart update error:', err));
  };

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // ─── ADD TO CART ───
  // Leave full product forms alone so Shopify apps can handle pricing, properties, and submit hooks normally.

  document.querySelectorAll('button[data-atc]:not([type="submit"])').forEach(btn => {
    if (btn.dataset.ajaxCartBound === 'true') return;
    btn.dataset.ajaxCartBound = 'true';
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const variantId = btn.dataset.variantId;
      if (!variantId) return;
      btn.disabled = true;
      const originalText = btn.textContent;
      btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(async r => {
        const data = await r.json();
        if (!r.ok) throw data;
        return data;
      })
      .then(() => {
        btn.textContent = 'Added!';
        setTimeout(() => {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1200);
        window.openCartDrawer();
      })
      .catch(err => {
        console.warn('Quick add error:', err);
        btn.textContent = 'Error';
        setTimeout(() => {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1500);
      });
    });
  });

  // ─── PRODUCT GALLERY ───
  const thumbs = document.querySelectorAll('.product-gallery-thumb');
  const mainImg = document.querySelector('.product-gallery-main img');
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', function() {
      thumbs.forEach(t => t.classList.remove('active'));
      this.classList.add('active');
      if (mainImg) mainImg.src = this.querySelector('img').src.replace('_72x72', '');
    });
  });

  // ─── VARIANT SELECTION ───
  document.querySelectorAll('.variant-btn').forEach(btn => {
    btn.addEventListener('click', function() {
      const group = this.closest('.variant-buttons');
      group.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('selected'));
      this.classList.add('selected');
      const atcBtn = document.querySelector('[data-atc]');
      if (atcBtn && this.dataset.variantId) {
        atcBtn.dataset.variantId = this.dataset.variantId;
        atcBtn.disabled = this.classList.contains('sold-out');
        atcBtn.textContent = this.classList.contains('sold-out') ? 'Sold Out' : 'Add to Cart';
      }
    });
  });

  // ─── QTY SELECTOR ───
  document.querySelectorAll('.qty-selector').forEach(sel => {
    const input = sel.querySelector('input');
    sel.querySelector('.qty-minus')?.addEventListener('click', () => {
      if (input && parseInt(input.value) > 1) input.value = parseInt(input.value) - 1;
    });
    sel.querySelector('.qty-plus')?.addEventListener('click', () => {
      if (input) input.value = parseInt(input.value) + 1;
    });
  });

  // ─── FILTER PILLS ───
  document.querySelectorAll('.filter-pill').forEach(pill => {
    pill.addEventListener('click', function() {
      this.closest('.filter-pills').querySelectorAll('.filter-pill').forEach(p => p.classList.remove('active'));
      this.classList.add('active');
    });
  });

  // ─── NEWSLETTER FORM ───
  document.querySelectorAll('.email-form').forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      const input = this.querySelector('input[type="email"]');
      const btn = this.querySelector('button');
      if (!input?.value) return;
      btn.textContent = 'Subscribed! ✓';
      input.value = '';
      setTimeout(() => btn.textContent = 'Subscribe', 3000);
    });
    // Also handle button click without submit
    const btn = form.querySelector('button');
    btn?.addEventListener('click', function(e) {
      if (form.querySelector('input[type="email"]')?.value) {
        btn.textContent = 'Subscribed! ✓';
        setTimeout(() => btn.textContent = 'Subscribe', 3000);
      }
    });
  });

  // Initialize cart count on load
  refreshCartDrawer();

})();
